import MigrationTable from "/src/features/plugins/migrations/components/MigrationTable/MigrationTable";

function MigrationList() {

    return <MigrationTable/>
}

export default MigrationList;